export interface ApiModuleConfig {
  api?: any;
  dictionariesApi?: string;
  entitlementsApi?: string;
  tokenFactory?: () => string;
}
